import { useAppSelector } from "app/hooks";
import { selectJobSeekerRolesInCommunity, selectAdminInCommunitiesSelectList, selectJobSeeker } from 'features/job-seeker-auth';
import { selectUser } from "features/auth";
import { selectJobSeekerOnBehalfOfOrganizationAdminId } from "features/job-seeker-on-behalf-of-organization-admin";
import { OnBehalfOfOrganizationAdmin } from 'features/job-seeker-on-behalf-of-organization-admin/types';
import { Roles, MemberRoles } from "features/types";
import { getAdminRoleInCommunity, checkIsLeadInProgram } from 'utils/job-seeker-on-behalf-of-organization-helper';
import RedirectToHomePage from 'components/RedirectToHomePage';

type Props = {
  children: React.ReactNode;
  roles: (Roles | MemberRoles)[];
  elseRedirectToHome?: boolean;
  elseChildren?: React.ReactNode;
  validateOrgnizationContext?: boolean;
  validateProgramLeadContext?: boolean;
  validateProgramLeadContextId?: string;
  orCondition?: (jobSeekerRoles: MemberRoles[], jobSeekerRolesInCommunity: MemberRoles[], isAdminInCommunitiesSelectList: OnBehalfOfOrganizationAdmin[], onBehalfOfOrganizationAdminId: string | undefined) => boolean;
};

const ShowForUserOrMemberRoles = ({ children, roles, elseChildren, validateOrgnizationContext, validateProgramLeadContext, validateProgramLeadContextId = 'none', elseRedirectToHome, orCondition }: Props) => {
  const user = useAppSelector(selectUser);
  const onBehalfOfOrganizationAdminId = useAppSelector(selectJobSeekerOnBehalfOfOrganizationAdminId);
  const jobSeekerRolesInCommunity = useAppSelector(selectJobSeekerRolesInCommunity);
  const isAdminInCommunitiesSelectList = useAppSelector(selectAdminInCommunitiesSelectList);
  const jobSeeker = useAppSelector(selectJobSeeker);
  const IsLeadInProgramId = validateProgramLeadContext ? checkIsLeadInProgram(jobSeeker, validateProgramLeadContextId) : false;

  const jobSeekerRoles: MemberRoles[] = [];
  if (validateOrgnizationContext === true) {
    if (onBehalfOfOrganizationAdminId) {
      if (roles.includes(MemberRoles.FullAdmin) || roles.includes(MemberRoles.ViewOnlyAdmin)) {
        const adminRoleInCommunity = getAdminRoleInCommunity(onBehalfOfOrganizationAdminId, isAdminInCommunitiesSelectList);
        if (adminRoleInCommunity) jobSeekerRoles.push(adminRoleInCommunity as unknown as MemberRoles);
      }
    } else {
      if (jobSeekerRolesInCommunity.includes(MemberRoles.Member)) jobSeekerRoles.push(MemberRoles.Member);
      if (jobSeekerRolesInCommunity.includes(MemberRoles.ProgramLead) && (!validateProgramLeadContext || IsLeadInProgramId)) jobSeekerRoles.push(MemberRoles.ProgramLead);
    }
  } else {
    jobSeekerRoles.push(...jobSeekerRolesInCommunity);
  }

  if ((user && roles.includes(user.role)) || jobSeekerRoles.some(role => roles.includes(role)) || (orCondition && orCondition(jobSeekerRoles, jobSeekerRolesInCommunity, isAdminInCommunitiesSelectList, onBehalfOfOrganizationAdminId))) {
    return <>{children}</>;
  }
  if (elseRedirectToHome) return <RedirectToHomePage />;
  if (elseChildren) return <>{elseChildren}</>;
  return null;
};

export default ShowForUserOrMemberRoles;
